import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type SchoolFilter } from '../types/filters';

export const schoolDefinition: FilterDefinition<SchoolFilter> = {
  id: FilterId.SCHOOL,
  name: 'School',
  type: FilterType.SCHOOL,
  schoolResultItems: {},
  isVisible: true,
};

export const schoolHandler: FilterHandler<SchoolFilter> = {
  isActive(currentFilterState: SchoolFilter) {
    return Object.keys(currentFilterState.schoolResultItems).length > 0;
  },
  isDefault(currentFilterState: SchoolFilter) {
    return Object.keys(currentFilterState.schoolResultItems).length === 0;
  },
  getEffectiveFilter(currentFilterState: SchoolFilter) {
    return { ...currentFilterState };
  },
};
